import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import FormTemplate from './Template'

const FooterControl = (props) => {
  return <FormTemplate props={props} layout="footer" />
}

export const footerControlTester = rankWith(3, scopeEndsWith('footer'))

export default withJsonFormsControlProps(FooterControl)
